
export class TrackingStatus {

  public id: string;
  public status: string;
  public institutionId: string;
}
